import type { DocumentTypeFindInterface } from '@zaoblako/shared/modules/document/dtos/document-type/document-type-find.dto';
import { DocumentCalculationMethodEnum } from '@zaoblako/shared/modules/document/enums/document.calculation.method.enum';
import { DocumentCalculationMethodNamePipe } from '@zaoblako/web/shared/pipes/document-calculation-method-name.pipe';

export interface DocumentTypeTreeOption {
  name: string;
  code: DocumentCalculationMethodEnum;
  children: DocumentTypeFindInterface[];
}

export function buildDocumentTypeTreeOptions(documentTypes: DocumentTypeFindInterface[]): DocumentTypeTreeOption[] {
  if (!Array.isArray(documentTypes)) {
    return [];
  }

  const methodNamePipe = new DocumentCalculationMethodNamePipe();

  return Object.values(DocumentCalculationMethodEnum).map((calcMethod) => ({
    name: methodNamePipe.transform(calcMethod),
    code: calcMethod,
    children: documentTypes
      .filter((documentType) => documentType.method === calcMethod)
      .sort((a, b) => (a.name < b.name ? -1 : 1))
  }));
}
